export default __webpack_public_path__ + "static/media/user.0d507a3c.svg";